import { App } from 'antd';

import { useIntl, useRequest } from '@umijs/max';

import { getSettings, updateSettings } from './index';

export const useSettings = () => useRequest(getSettings, {
  cacheKey: 'settings',
  formatResult: data => ({
    complaintThresholdEnabled: data.complaintThresholdEnabled,
    endTime: data.endTime,
    endTimeHour: Number(data.endTime.split(':')[0]),
    endTimeMinute: Number(data.endTime.split(':')[1]),
    startTime: data.startTime,
    startTimeHour: Number(data.startTime.split(':')[0]),
    startTimeMinute: Number(data.startTime.split(':')[1]),
  }),
  staleTime: Infinity,
});

export const useUpdateSettings = () => {
  const intl = useIntl();
  const { message } = App.useApp();

  return useRequest(updateSettings, {
    cacheKey: 'updateSettings',
    manual: true,
    onError: () => {
      message.error(intl.formatMessage({ id: 'common.fetch.failure' }));
    },
    onSuccess: () => {
      message.success(intl.formatMessage({ id: 'common.update.success' }));
    },
  });
};
